import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

// models
import { IGroupedSelectData } from '../../models/groupedSelectData';

// services
import { Utils } from '../../services/utils.service';

import { SHARED_MODULES } from '../../../shared.';

@Component({
    selector: 'ph-grouped-select[data]',
    templateUrl: './ph-grouped-select.component.html',
    styleUrls: ['./ph-grouped-select.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})
export class PhGroupedSelectComponent implements OnInit {

	data: Array<IGroupedSelectData>;
	formControl: FormControl<IGroupedSelectData>;

	@Input('disabled') set disabled(value: boolean) {
		if (!this.formControl) return;
		if (value) {
			this.formControl.disable({ emitEvent: false });
		} else {
			this.formControl.enable({ emitEvent: false });
		}
	}
	@Input('selectedValue') set changeSelected(value: string | number) {
		this.setSelected(value);
	}
	@Input('data') set setData(value: Array<IGroupedSelectData>) {
		this.data = value;
		this.formControl.setValue(this.data[0], { emitEvent: false });
	};

	@Output('changeValue') changeValueEmitter: EventEmitter<IGroupedSelectData> = new EventEmitter<IGroupedSelectData>();

	constructor() {
		this.formControl = new FormControl<IGroupedSelectData>({ value: null, disabled: this.disabled });
	}

	ngOnInit(): void {
		this.formControl.valueChanges.subscribe((value: IGroupedSelectData) => {
			this.changeValueEmitter.emit(value);
		});
	}

	setGroupOpened(group: IGroupedSelectData): void {
		if (!group.opened) {
			group.opened = true;
		} else {
			if (this.formControl.value.parent?.value !== group.value) group.opened = false;
		}
	}

	setSelected(value: string | number): void {
		if (!this.data) return;

		let foundGroup: IGroupedSelectData = this.data
			.concat(Utils.to1DArray(this.data.map((group: IGroupedSelectData) => group.children || [])))
			.find((group: IGroupedSelectData) => group.value === value);

		if (foundGroup) {
			this.formControl.setValue(foundGroup, { emitEvent: false });
			if (foundGroup.children) {
				foundGroup.opened = true;
			}
			if (foundGroup.parent) {
				const parent: IGroupedSelectData = this.data?.find((group: IGroupedSelectData) => group.value === foundGroup.parent.value);
				if (parent) parent.opened = true;
			}
		}
	}
}
